const Maintenance = () => (
    <div className="page-wrap">
        <div className="page-center" style={{ flexDirection: 'column', gap: '14px', textAlign: 'center' }}>
            <svg width="40" height="40" fill="none" stroke="var(--muted)" strokeWidth="1.6" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <h1 style={{ margin: 0 }}>Sorry — technical works in progress</h1>
            <p style={{ color: 'var(--muted)', maxWidth: '440px', margin: 0, lineHeight: 1.6 }}>
                Purchases and renewals are temporarily unavailable while we upgrade our payment
                system. Please check back soon — your existing subscriptions and activation codes
                are unaffected.
            </p>
            <p style={{ color: 'var(--muted)', fontSize: '.85rem', margin: 0 }}>
                Questions? <a href="mailto:team@desktopcallrecorder.com">team@desktopcallrecorder.com</a>
            </p>
        </div>
    </div>
);

export default Maintenance;
